import { ITranslations, LocalizationModel } from '../utils/localization'
import { LocalizationContext } from './LocalizationContext'

export interface LocalizationContextProviderProps {
  lang: string
  model: LocalizationModel
  children: React.ReactNode
}

export function LocalizationContextProvider<T extends ITranslations>({
  lang,
  model,
  children
}: LocalizationContextProviderProps) {
  const translations = model[lang] as T

  return <LocalizationContext.Provider value={{ translations }}>{children}</LocalizationContext.Provider>
}
